module.exports = __webpack_public_path__ + "static/media/display-3@768.2613a269.png";